import { useFeature } from "@growthbook/growthbook-react"
import cn from "classnames"

import styles from "./styles.module.scss"

import { HeaderUserPicture } from "components/Header/components/HeaderUserPicture"
import { MenuDesktop } from "components/Header/components/MenuDesktop"
import { MenuMobile } from "components/Header/MenuMobile"

export function HeaderMenu() {
    const { value: experimentClosedProduct } = useFeature<boolean>("closed-product")

    return (
        <div
            className={cn(styles.headerMenu, {
                [styles.isReverse]: experimentClosedProduct,
            })}
        >
            <MenuDesktop hide={experimentClosedProduct} />
            <MenuMobile showDesktop={experimentClosedProduct} />
            <HeaderUserPicture isAdaptive={!experimentClosedProduct} />
        </div>
    )
}
